(() => {
  'use strict';

  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  };

  const initBundle = (root) => {
    if (!root || root.dataset.ebookReady === 'true') return;
    root.dataset.ebookReady = 'true';
    const checks = [...root.querySelectorAll('[data-ebook-bundle-item]')];
    const count = root.querySelector('[data-ebook-bundle-count]');
    const total = root.querySelector('[data-ebook-bundle-total]');
    const button = root.querySelector('[data-ebook-bundle-add]');
    const status = root.querySelector('[data-ebook-bundle-status]');
    const currency = root.dataset.currency || 'USD';

    const update = () => {
      const selected = checks.filter((item) => item.checked && !item.disabled);
      const cents = selected.reduce((sum, item) => sum + Number(item.dataset.price || 0), 0);
      if (count) count.textContent = String(selected.length);
      if (total) total.textContent = money(cents, currency);
      if (button) button.disabled = selected.length === 0;
    };

    checks.forEach((item) => item.addEventListener('change', update));
    update();

    if (!button) return;
    button.addEventListener('click', async () => {
      const selected = checks.filter((item) => item.checked && !item.disabled);
      if (!selected.length || button.disabled) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (status) status.textContent = button.dataset.loading || 'Adding your ebooks…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: selected.map((item) => ({ id: Number(item.value), quantity: 1 })) })
        });
        if (!response.ok) throw new Error('Cart request failed');
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: root.dataset.afterAdd === 'drawer' } }));
        if (status) status.textContent = button.dataset.success || 'Bundle added to your cart.';
        button.textContent = button.dataset.success || 'Added to cart';
        if (root.dataset.afterAdd === 'cart') window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      } catch (error) {
        if (status) status.textContent = button.dataset.error || 'Could not add this bundle. Please try again.';
        button.disabled = false;
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  };

  const init = (scope = document) => scope.querySelectorAll('[data-ebook-bundle]').forEach(initBundle);
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
